<!-- EXTREMELY CRUCIAL -->
<!-- This component only works with a `roles` or an `allRoles` value in root Vuex state. This is an awkward pattern to assume, but so much of -->
<!-- the old Vue world was built with this assumption, that I feel comfortable making a prefab that requires it. -->
<!-- Make absolute sure that such a value exists in state before using this prefab. -->
<template>
  <component
    :is="selectorComponent"
    v-model="selection"
    :options="options"
    :placeholder="props.placeholder"
    :key-map="keyMap"
    :form-name="props.formName"
    :allow-clear="props.allowClear"
    :allow-search="props.allowSearch"
    :update-function="props.updateFunction"
    :update-action="props.updateAction"
  />
</template>

<script setup>
  import { computed } from 'vue';
  import { useStore } from 'vuex';

  const props = defineProps({
    modelValue: { type: [Object, Array], default: null },
    placeholder: { type: String, default: 'Search team roles...' },
    keyMap: { type: Object, default: null },
    formName: { type: String, default: null },
    allowClear: { type: Boolean, default: false },
    allowSearch: { type: Boolean, default: true },
    updateFunction: { type: Function, default: null },
    updateAction: { type: String, default: null },
    isMulti: { type: Boolean, default: false },
  });
  const emit = defineEmits(['update:modelValue']);
  const { state } = useStore();

  const selectorComponent = computed(() => (props.isMulti ? 'donut-selector-multi-static' : 'donut-selector-single-static'));

  // TODO: Just clean up the duplicate variable names serving the same purpose, and remove this calculation everywhere.
  const options = computed(() => state.roles || state.allRoles);
  const selection = computed({
    get() { return props.modelValue; },
    set(value) {
      // This will only get hit if the donut-selector-single-static emits update:modelValue,
      // which is to say if we aren't passing in anything as props.updateFunction or props.updateAction
      emit('update:modelValue', value);
    },
  });

  const keyMap = computed(() => ({ value: 'id', label: 'name', ...props.keyMap }));
</script>
